import axios from "axios";

export const API = axios.create({
   baseURL: "https://olamworldadmin.skyapi.store/",
  //baseURL: "http://localhost:3677/",
});
